export function getAssetPath(path) {
    return `${process.env.PUBLIC_URL}${path}`;
  }